import { Navigate, useLocation } from "react-router-dom";

export default function CompensationProfilesViewRedirect() {
  const location = useLocation();
  // Redirect from /people/:pgaId/career/compensation-profiles/:compProfileId/view to /people/:pgaId/career/compensation/:compProfileId/view
  const newPath = location.pathname.replace("/compensation-profiles/", "/compensation/");
  return <Navigate to={`${newPath}${location.search}`} replace />;
}
